export enum SignedState {
    NotSet = 'NotSet',
    Pending = 'Pending',
    Signed = 'Signed'
}